import { CustomerType } from "src/api-service";

// **************************************************************************
// CUSTOMER TYPE STATE
// **************************************************************************
export interface CustomerTypeState {
    customerType: CustomerType | null;
    customerTypes: CustomerType[];
    customerTypesLoading: boolean;
}

export const initialCustomerTypeState: CustomerTypeState = {
    customerType: null,
    customerTypes: [],
    customerTypesLoading: false,
};
